import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="grid min-h-[80vh] place-items-center bg-[#F9F8F6] text-[#16302B]">
        <div className="text-center">
          <p className="eyebrow">Checking access</p>
          <p className="mt-3 font-display text-xl font-bold tracking-tight">One sec…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
